export const localStorageKey = {
  accessToken: 'accessToken',
  storyCardTooltipFirstVisible: 'storyCardTooltipFirstVisible',
  loginRedirectUrl: 'loginRedirectUrl',
} as const
